import React, { useEffect, useState } from "react";
// import { images } from '../../assets/images'
// import EventNotFound from '../../components/common/EventCard/EventNotFound'
import EventListCard from "../../components/common/EventCard/EventListCard";
import { getAllOrganizerEvents,getAllEventByQuery } from "../../api";
import EventNotFound from "../../components/common/EventCard/EventNotFound";
import { EventType } from "../../types/Events";
import { images } from "../../assets/images";
import { get } from "http";
import PulseLoader from "react-spinners/PulseLoader";

import Select from "react-select";

type EventsProps = {};

const OrganizerDashboard = (props: EventsProps) => {
  const [eventList, setEventList] = useState<EventType[]>([]);
  const [organizerInfo, setOrganizerInfo] = useState<any>({});
  const [onlineEventList, setOnlineEventList] = useState<EventType[]>([]);
  const [offlineEventList, setOfflineEventList] = useState<EventType[]>([]);
  const [currentTab, setCurrentTab] = useState("all");
  const [search, setSearch] = useState("");
  const [eventStatus, setEventStatus] = useState<"all" | "draft" | "active">("all");
  const [loading, setLoading] = useState<boolean>(true);

  // Options for react-select
  const statusOptions = [
    { value: "all", label: "All Status" },
    { value: "draft", label: "Draft" },
    { value: "active", label: "Active" },
  ];

  // Dark glass select — matches theme tokens (not Bootstrap blue)
  const customSelectStyles = {
    control: (provided: any, state: any) => ({
      ...provided,
      minHeight: "40px",
      height: "40px",
      background: "rgba(255, 255, 255, 0.05)",
      borderColor: state.isFocused ? "rgba(238, 63, 124, 0.45)" : "rgba(255, 255, 255, 0.08)",
      boxShadow: state.isFocused ? "0 0 0 2px rgba(238, 63, 124, 0.15)" : "none",
      borderRadius: "12px",
      fontSize: "13px",
      width: "100%",
      minWidth: "140px",
      color: "#fff",
      cursor: "pointer",
      "&:hover": {
        borderColor: "rgba(238, 63, 124, 0.35)",
      },
    }),
    singleValue: (provided: any) => ({
      ...provided,
      color: "#fff",
      fontSize: "13px",
    }),
    placeholder: (provided: any) => ({
      ...provided,
      color: "rgba(255, 255, 255, 0.4)",
    }),
    valueContainer: (provided: any) => ({
      ...provided,
      padding: "0 10px",
    }),
    input: (provided: any) => ({
      ...provided,
      margin: "0px",
      color: "#fff",
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    indicatorsContainer: (provided: any) => ({
      ...provided,
      height: "40px",
    }),
    dropdownIndicator: (provided: any) => ({
      ...provided,
      padding: "8px",
      color: "rgba(255, 255, 255, 0.45)",
    }),
    menu: (provided: any) => ({
      ...provided,
      zIndex: 9999,
      background: "#16161c",
      border: "1px solid rgba(255, 255, 255, 0.08)",
      borderRadius: "12px",
      overflow: "hidden",
    }),
    menuPortal: (provided: any) => ({
      ...provided,
      zIndex: 9999,
    }),
    option: (provided: any, state: any) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? "rgba(238, 63, 124, 0.85)"
        : state.isFocused
          ? "rgba(255, 255, 255, 0.06)"
          : "transparent",
      color: "#fff",
      fontSize: "13px",
      padding: "10px 12px",
      cursor: "pointer",
    }),
  };
  useEffect(() => {
    try {
      const venueOrganizerData = localStorage.getItem("venueOrganizerData");
      if (venueOrganizerData) setOrganizerInfo(JSON.parse(venueOrganizerData));
    } catch (err) {
      console.error("Error fetching organizer info:", err);
    }
  }, []);
  useEffect(() => {
    if (!organizerInfo?.organizerId) return; 
    const fetchEvents = async () => {
      try {
        setLoading(true);
        const response = await getAllEventByQuery("organizerId", organizerInfo.organizerId);
        if(response){
        const now = new Date();
        const futureEvents = response.filter(
          (event: EventType) => new Date(event.eventDate) >= now
        );
        const pastEvents = response.filter(
          (event: EventType) => new Date(event.eventDate) < now
        );
        const sortedFuture = [...futureEvents].sort(
          (a, b) =>
            new Date(a.eventDate).getTime() - new Date(b.eventDate).getTime()
        );
        const sortedPast = [...pastEvents].sort(
          (a, b) =>
            new Date(b.eventDate).getTime() - new Date(a.eventDate).getTime()
        );
        const combinedSortedEvents = [...sortedFuture, ...sortedPast];
        setEventList(combinedSortedEvents);
        const onlineEvents = combinedSortedEvents.filter(
          (event: EventType) => event.eventType === "online"
        );
        const offlineEvents = combinedSortedEvents.filter(
          (event: EventType) => event.eventType === "offline"
        );
        setOnlineEventList(onlineEvents);
        setOfflineEventList(offlineEvents);
      }
      } catch (error) {
        console.error("Error fetching events:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchEvents();
  }, [organizerInfo.organizerId]);

  const handleSearch = (e: any) => {
    const searchValue = e.target.value;
    setSearch(searchValue);
    // Don't modify the original eventList - just update the search state
    // The filtering will be handled in the render functions
  };
  // Helper function to filter events by search term
  const filterEventsBySearch = (events: EventType[]) => {
    if (search.length === 0) {
      return events;
    }
    return events.filter(
      (event: EventType) =>
        event.eventName.toLowerCase().includes(search.toLowerCase()) ||
        (event.shortDescription &&
          event.shortDescription
            .toLowerCase()
            .includes(search.toLowerCase())) ||
        (event.eventStatus &&
          event.eventStatus.toLowerCase().includes(search.toLowerCase()))
    );
  };

  const renderEventTable = () => {
    let eventsToRender: EventType[] = [];

    if (currentTab === "online") {
      eventsToRender = filterEventsByStatus(onlineEventList);
    } else if (currentTab === "offline") {
      eventsToRender = filterEventsByStatus(offlineEventList);
    } else {
      eventsToRender = filterEventsByStatus(eventList);
    }

    // Apply search filter
    eventsToRender = filterEventsBySearch(eventsToRender);

    return eventsToRender.map((event: EventType) => (
      <EventListCard
        key={event.eventId}
        eventName={event.eventName}
        eventShortDescription={event.shortDescription || ""}
        bannerImg={
          event.bannerImgDesktop !== ""
            ? event.bannerImgDesktop
            : event.thumbImg !== ""
            ? event.thumbImg
            : images.noEvent
        }
        eventStatus={(() => {
          if (event.eventStatus === "draft") {
            return "Draft";
          } else if (event.eventStatus === "active") {
            return "Live";
          } else {
            return event.eventStatus || "Draft";
          }
        })()}
        eventDate={event.eventDate}
        totalTicket={100}
        soldTicket={50}
        eventId={Number(event.eventId)}
        eventData={event}
        eventTime={event.eventTime}
      />
    ));
  };
  // Helper function to filter events by status
  const filterEventsByStatus = (events: EventType[]) => {
    if (eventStatus === "all") {
      return events;
    }
    return events.filter((event: EventType) => {
      // Use existing eventStatus field or fallback logic
      if (eventStatus === "draft") {
        // Events that are in draft state or not published
        return (
          event.eventStatus === "draft" ||
          event.status === "draft" ||
          event.eventStatus === "Draft"
        );
      } else if (eventStatus === "active") {
        // Events that are published and active
        return (
          event.eventStatus === "active" || event.eventStatus === "published"
        );
      }
      return true;
    });
  };

  // Helper function to get filtered event count
  const getFilteredEventCount = (tabType: string) => {
    let eventsToFilter: EventType[] = [];

    if (tabType === "online") {
      eventsToFilter = onlineEventList;
    } else if (tabType === "offline") {
      eventsToFilter = offlineEventList;
    } else {
      eventsToFilter = eventList;
    }

    // Apply both status and search filters
    const statusFiltered = filterEventsByStatus(eventsToFilter);
    const searchFiltered = filterEventsBySearch(statusFiltered);

    return searchFiltered.length;
  };

  const renderCount = () => {
    if (currentTab === "online") {
      return getFilteredEventCount("online");
    } else if (currentTab === "offline") {
      return getFilteredEventCount("offline");
    } else {
      return getFilteredEventCount("all");
    }
  };

  const getVisibleEvents = () => {
    let eventsToCheck: EventType[] = [];
    if (currentTab === "online") {
      eventsToCheck = filterEventsByStatus(onlineEventList);
    } else if (currentTab === "offline") {
      eventsToCheck = filterEventsByStatus(offlineEventList);
    } else {
      eventsToCheck = filterEventsByStatus(eventList);
    }
    return filterEventsBySearch(eventsToCheck);
  };

  return (
    <>
      <div className="ex-events-page">
        {/* Organizer identity */}
        <div className="ex-org-hero">
          <div className="ocard-left">
            <div className="ocard-avatar">
              <img src={organizerInfo.profilePic} alt={organizerInfo.name || "Organizer"} />
            </div>
            <div className="ocard-name">
              <h4>{organizerInfo.name}</h4>
              <span>{organizerInfo.email}</span>
            </div>
          </div>
        </div>

        <div className="ex-page-header">
          <span className="ex-page-eyebrow">Organizer</span>
          <h1 className="ex-page-title">
            <i className="fa-solid fa-calendar-days me-2" aria-hidden="true"></i>
            Events
          </h1>
          <p className="ex-page-sub">{renderCount()} events</p>
        </div>

        {/* Single even filter rail */}
        <div className="ex-filters-rail">
          <div className="ex-filter-search">
            <div className="relative-input position-relative">
              <input
                className="form-control h_40"
                type="text"
                placeholder="Search by event name, status"
                value={search}
                onChange={(e) => handleSearch(e)}
              />
              <i className="uil uil-search"></i>
            </div>
          </div>

          <div className="ex-filter-status">
            <Select
              options={statusOptions}
              value={statusOptions.find((option) => option.value === eventStatus)}
              onChange={(selectedOption: any) =>
                setEventStatus(selectedOption.value)
              }
              styles={customSelectStyles}
              isSearchable={false}
              placeholder="Select Status"
              className="react-select-container"
              classNamePrefix="react-select"
              menuPortalTarget={typeof document !== "undefined" ? document.body : null}
              menuPosition="fixed"
            />
          </div>

          <div className="nav custom2-tabs btn-group ex-filter-tabs" role="tablist">
            <button
              className={`tab-link ${currentTab === "all" ? "active" : ""}`}
              onClick={() => setCurrentTab("all")}
              type="button"
              role="tab"
              aria-selected={currentTab === "all"}
            >
              All Event (
              <span className="total_event_counter">
                {getFilteredEventCount("all")}
              </span>
              )
            </button>
            <button
              className={`tab-link ${currentTab === "online" ? "active" : ""}`}
              onClick={() => setCurrentTab("online")}
              type="button"
              role="tab"
              aria-selected={currentTab === "online"}
            >
              Online Event (
              <span className="total_event_counter">
                {getFilteredEventCount("online")}
              </span>
              )
            </button>
            <button
              className={`tab-link ${currentTab === "offline" ? "active" : ""}`}
              onClick={() => setCurrentTab("offline")}
              type="button"
              role="tab"
              aria-selected={currentTab === "offline"}
            >
              Venue Event (
              <span className="total_event_counter">
                {getFilteredEventCount("offline")}
              </span>
              )
            </button>
          </div>
        </div>

        <div className="event-list">
          <div className="tab-content">
            {loading ? (
              <div className="d-flex justify-content-center my-5">
                <PulseLoader color="#EE3F7C" size={12} />
              </div>
            ) : getVisibleEvents().length <= 0 ? (
              <EventNotFound />
            ) : (
              renderEventTable()
            )}
          </div>
        </div>
      </div>
    </>
  );
};
export default OrganizerDashboard;
